import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;

//地址列表
export const addressList = (params) => {
  return axios.get(`${base}/api/Address/GetAddressInfos`, { params: params });
};
//新增地址
export const addAddress = (params) => {
  return axios.post(`${base}/api/Address/AddAddress`, params);
};
//修改地址
export const updateAddress = (params) => {
  return axios.put(`${base}/api/Address/PutAddress`, params);
};
//删除地址
export const deleteAddress = (params) => {
  return axios.delete(`${base}/api/Address/DeleteAddress`, { params: params });
};
//批量删除地址
export const batchDeleteAddress = (params) => {
  return axios.post(`${base}/api/Address/DeletesAddress`, params);
};
